/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { isSupportedUserAgent as isMobileUserAgent } from '@atlassian/jira-common-is-mobile-user-agent';
import { projectSettingsServicedeskTicketTypesConfigRoute } from '@jira/router-routes__project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskTicketTypesConfigRoute.tsx';
import { projectSettingsServicedeskItsmTicketTypesConfigRoute } from '@jira/router-routes__project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskItsmTicketTypesConfigRoute.tsx';
import { projectSettingsServicedeskUnassignedTicketTypesConfigRoute } from '@jira/router-routes__project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskUnassignedTicketTypesConfigRoute.tsx';
import { servicedeskGettingStartedRequestTypesRoute } from '@jira/router-routes__servicedesk-getting-started-page-routes/src/servicedeskGettingStartedRequestTypesRoute.tsx';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';

const REQUEST_TYPE_PAGE_ROUTES = [
	projectSettingsServicedeskTicketTypesConfigRoute.name,
	projectSettingsServicedeskItsmTicketTypesConfigRoute.name,
	projectSettingsServicedeskUnassignedTicketTypesConfigRoute.name,
	servicedeskGettingStartedRequestTypesRoute.name,
];

export const shouldRouteShowQuickstartOnboarding = (routeName: RouteName): boolean => {
	if (isMobileUserAgent()) {
		return false;
	}

	const allowedRoutes: RouteName[] = [
		'servicedesk-queues-landing',
		'servicedesk-queues-custom-view',
		'legacy-project-settings-edit',
		'legacy-project-settings-people',
		'project-settings-servicedesk-customer-notifications',
		'project-settings-servicedesk-email',
		'project-settings-servicedesk-portal-settings',
		'project-settings-servicedesk-ticket-types-config',
		'project-settings-servicedesk-chat',
	];

	return allowedRoutes.includes(routeName);
};

export const shouldRenderRequestTypesTableViewSettings = (routeName: RouteName): boolean =>
	REQUEST_TYPE_PAGE_ROUTES.includes(routeName);
